var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"auster-btn",class:_vm.classObject,style:({
    backgroundColor: _vm.background,
    color: _vm.color,
    borderColor: _vm.borderColor,
  }),attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.onClick}},[(_vm.loadingBtn)?_c('clip-loader',{attrs:{"color":"#2E7179","size":"20px"}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }